"use client";

import { toast } from "react-toastify";
import { smartOpen } from "@/utils/deeplink";

export default function PiBrowserCta({
  variant = "full",
  path,
  query = {},
  label = "🚀 Open in Pi Browser",
}) {
  const buildMergedQuery = () => {
    const current = new URL(window.location.href);
    return {
      ...Object.fromEntries(current.searchParams.entries()),
      ...query,
    };
  };

  const handleOpen = () => {
    const current = new URL(window.location.href);

    const opts = {
      host: "reloadpi.com",
      path: path || current.pathname,
      query: buildMergedQuery(),
      onNoMobile: async ({ scheme }) => {
        try {
          await navigator.clipboard.writeText(scheme);
          toast.info(
            "Desktop detected. Link copied — open Pi Browser on your phone."
          );
        } catch {
          toast.info("Desktop detected. Open Pi Browser on your phone.");
        }
      },
    };

    if (window.isNativeWrapper && window.ReloadPiNative?.openExternal) {
      const { scheme, intent, play, appstore } = smartOpen(opts);
      const isAndroid = /android/i.test(navigator.userAgent);
      const primary = isAndroid ? intent : scheme;
      const fallback = isAndroid ? play : appstore;

      window.ReloadPiNative.openExternal(primary);

      if (fallback) {
        setTimeout(() => {
          window.ReloadPiNative.openExternal(fallback);
        }, 1200);
      }
    } else {
      smartOpen(opts);
    }
  };

  const handleCopy = async () => {
    try {
      const mergedQuery = buildMergedQuery();
      const url = new URL(`https://reloadpi.com${path || window.location.pathname}`);

      Object.entries(mergedQuery).forEach(([key, value]) => {
        if (value != null && value !== "") {
          url.searchParams.set(key, String(value));
        }
      });

      await navigator.clipboard.writeText(url.toString());
      toast.success("📋 Link copied! Open Pi Browser and paste it.");
    } catch {
      toast.error("Could not copy the link.");
    }
  };

  if (variant === "compact") {
    return (
      <div className="flex flex-col items-center gap-2">
        <button
          onClick={handleOpen}
          className="px-4 py-2 bg-primary text-white rounded-md font-medium hover:bg-accent transition"
        >
          {label}
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2">
      <button
        onClick={handleOpen}
        className="px-4 py-2 bg-primary text-white rounded-md font-medium hover:bg-accent transition"
      >
        {label}
      </button>

      <button
        onClick={handleCopy}
        className="px-4 py-2 bg-muted text-textPrimary rounded-md font-medium hover:bg-muted/80 transition"
      >
        📎 Copy this page’s link
      </button>

      <p className="text-[11px] text-textPrimary mt-1 text-center">
        💡 Tip: Outside Pi Browser, checkout works normally using
        <span className="text-accent font-semibold"> Any Crypto</span>.
      </p>
    </div>
  );
}